import { render, staticRenderFns } from "./mobile-nav-body.vue?vue&type=template&id=483092fe&scoped=true"
import script from "./mobile-nav-body.vue?vue&type=script&lang=js"
export * from "./mobile-nav-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483092fe",
  null
  
)

export default component.exports